import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../api.ts';
import { Icon } from '../components/Icon.tsx';

/**
 * Точка приземления QR-ссылки https://druzza.ru/s/<public_id>.
 *
 * Сюда попадают и из встроенного сканера, и — чаще — прямо из штатной
 * камеры телефона, которая просто открывает ссылку. Код в адресе
 * сравнивается без учёта регистра: на этикетке он напечатан заглавными
 * (ТЗ 6.1).
 */
export function PublicIdScreen() {
  const { publicId } = useParams<{ publicId: string }>();
  const navigate = useNavigate();
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!publicId) return;
    api
      .specimenByPublicId(publicId)
      .then((s) => navigate(`/specimen/${s.id}`, { replace: true }))
      .catch(() => setMissing(true));
  }, [publicId, navigate]);

  if (!missing) {
    return (
      <div className="app">
        <div className="scroll muted small">Ищем образец…</div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="scroll empty">
        <Icon name="alert" className="icon icon-lg muted" />
        <h2>Образец не найден</h2>
        <p className="muted small">
          Возможно, он удалён. Код с этикетки: <code className="mono">{publicId}</code>
        </p>
        <Link className="btn btn--primary" to="/">
          <Icon name="search" className="icon icon-sm" /> Искать по каталогу
        </Link>
      </div>
    </div>
  );
}
